module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/observable/throw"
// module id = 10
// module chunks = 0